import Controller from '../abstracts/Controller';
import 'scss-templates/t-listing.scss';
import ActiveFiltersComponent from "../components/ActiveFiltersComponent";

export default class ListingController extends Controller {
  static get COMPONENTS() {
    return [
      'FiltersComponent',
      'PriceRangeComponent',
      'ShortcutComponent',
      'ListingHeadComponent',
      'CategoryFilterComponent',
      'SearchComponent',
      'PaginationComponent',
      'ProductCardSwatchesComponent',
      'ActiveFiltersComponent',
      'CarouselComponent',
      'RecommendationEngineComponent',
      'ListingEditorialComponent',
      'WishlistComponent',
      'VisualMerchandisingComponent',
      'HistoryManagerComponent',
      'SaleRangeComponent',
      'SalesScrollbarComponent'
    ];
  }
}
